export default "__VITE_ASSET__DLreFITe__"